/*
 * Module for handling localized and default category name
 */

define(["marionette", "messaging/messenger", "./categoryNamesLocalizedView"], function (
  Marionette,
  Messenger,
  CategoryNamesLocalizedView,
) {
  var CategoryNamesLocalizedController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "categoryNamesLocalized";
      this.region = options.region;
    },
    show: function (category, selectedLanguage) {
      this.category = category;
      this.names = this.category.getNamesLocalized();
      this.names.selectedLanguage = selectedLanguage;
      this.names.selectedLanguageId = selectedLanguage.get("id");
      this.names.categoryName = this.category.get("categoryName");
      var name = this.names.findWhere({ languageId: this.names.selectedLanguageId });
      if (!name) {
        this.newName = this.names.addNewValue();
        this.newName.set("languageId", this.names.selectedLanguageId);
        this.newName.set("categoryId", this.category.get("categoryId"));
      }
      this._setUpView();
      this.showRegion(this.view, { loading: true });
    },
    _setUpView: function () {
      this.view = new CategoryNamesLocalizedView.categoryNamesLocalizedView({
        collection: this.names,
      });
    },
  });

  return CategoryNamesLocalizedController;
});
